import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/blog/components/BlogEnquirySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/blog/components/BlogListClient.tsx");
